import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'gatsby';
import { routes } from 'languages';
import * as style from './EmergencyMessage.module.scss';

interface Props {
    message: string;
}

const EmergencyMessage = ({ message }: Props) => {
	const { locale } = useIntl();

    return (
        <Link className={style.wrapper} to={routes[locale]['/update-schedule/']}>
            <div className={style.icon} />
            <div
                className={style.message}
                dangerouslySetInnerHTML={{ __html: message }}
            />
        </Link>
    );
};
export default EmergencyMessage;